import { EllipsisVertical, Pencil } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { currencyFormat } from '@/helpers/stringHelpers';
import { convertToDateFormat } from '@/helpers/dateHelpers';

import { TableCell, TableRow } from '@/components/ui/table';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

import { useOrderObject } from '@/data/order';

const OrderRow = ({ orderId }) => {
  const order = useOrderObject(orderId);
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`/order/${orderId}`);
  };

  return (
    <TableRow onClick={handleRowClick} className="cursor-pointer">
      <TableCell className="py-2">#{order.orderNum}</TableCell>
      <TableCell className="py-2">
        {order.userFirstname} {order.userLastname}
      </TableCell>
      <TableCell className="py-2 text-right">
        {currencyFormat(order.total)}
      </TableCell>
      <TableCell className="py-2">
        {convertToDateFormat(order.createdAt)}
      </TableCell>
      <TableCell className="text-right py-2">
        <DropdownMenu>
          <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
            <Button variant="icon" size="icon" aria-label="Open menu">
              <EllipsisVertical size={18} />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent onClick={(e) => e.stopPropagation()}>
            <DropdownMenuLabel>#{order.orderNum}</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleRowClick}>
              <Pencil />
              View Order
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </TableCell>
    </TableRow>
  );
};

export default OrderRow;
